import { LitElement, html, css } from 'lit';
import { property, query } from 'lit/decorators.js';
import './components/langhout-beton-login/langhout-beton-login';
import './components/langhout-beton-list-orders/langhout-beton-list-orders';
import './components/langhout-beton-list-retour-orders/langhout-beton-list-retour-orders';
import './components/langhout-beton-create-retour-order/langhout-beton-create-retour-order';
import './components/langhout-beton-update-retour-order/langhout-beton-update-retour-order';
import './components/langhout-beton-view-retour-order/langhout-beton-view-retour-order';
import './components/langhout-beton-list-finished-orders/langhout-beton-list-finished-orders';
import './components/langhout-beton-create-pickup-order/langhout-beton-create-pickup-order';
import './components/langhout-beton-list-templates/langhout-beton-list-templates';
import './components/langhout-beton-list-users/langhout-beton-list-users';
import './components/langhout-beton-edit-users/langhout-beton-edit-users';
import './components/langhout-beton-list-accounts/langhout-beton-list-accounts';
import './components/langhout-beton-list-stock/langhout-beton-list-stock';
import './components/langhout-beton-view-stock/langhout-beton-view-stock';
import './components/langhout-beton-list-stock-count/langhout-beton-list-stock-count';
import './components/langhout-beton-view-stock-count/langhout-beton-view-stock-count';
import './components/langhout-beton-view-production-planning/langhout-beton-view-production-planning';

import './elements/langhout-button/langhout-button';
import { Router } from '@vaadin/router';
import './elements/StyleProvider';
import { Capacitor } from '@capacitor/core';
import {
  authenticatedAPICall,
  currentVersion,
  isSuccessfulAPIResponse,
} from './client/api-client';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { jwtDecode } from 'jwt-decode';
import {
  DOMAIN,
  JWT_KEY_LOCALSTORAGE,
  JWT_OTP_KEY_LOCALSTORAGE,
} from './environment/environment';
import { ConfirmEvent, Claims, User } from './types/types';
import { LanghoutCheckbox } from './elements/langhout-checkbox/langhout-checkbox';

import { hasScope } from './util/util';
import {
  accountsIcon,
  stockIcon,
  archiveIcon,
  closeIcon,
  createIcon,
  headerLogo100,
  homeIcon,
  menuIcon,
  signInIcon,
  logOutIcon,
  userIcon,
  settingsIcon,
  editIcon,
  factoryIcon,
  calendarIcon,
  retourIcon,
} from './elements/icons/icons';
import { getCurrentPath } from './util/list_util';
import { sharedStyles } from './elements/shared-styles';
import {
  christmasStyles,
  CHRISTMAS_THEME_ENABLED,
} from './elements/christmas-theme';

export class LanghoutBetonPortal extends LitElement {
  @property({ type: String }) title = 'Login';

  static styles = [
    sharedStyles,
    christmasStyles,
    css`
      :host {
        min-height: 100vh;
        max-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        font-size: 17px;
        color: var(--text-color-main);
        background-color: var(--background-color);
        text-align: center;
        position: relative;
        overflow: hidden;
      }

      style-provider {
        min-width: 100vw;
      }

      .header {
        width: calc(100% - 2px);
        min-height: 82px;
        max-height: 82px;
        padding: 1px;
        background-color: var(--menu-color);
        color: var(--text-color-light);
        display: flex;
        flex-direction: row;
        border-bottom: 2px solid white;
      }

      .menu-icon {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .menu-icon:hover {
        cursor: pointer;
        background-color: var(--primary-hover-color);
      }

      svg {
        padding: 20px;
        height: 30px;
        width: 30px;
      }

      #title {
        margin-left: 10px;
      }

      #title:hover {
        cursor: pointer;
      }

      h2 {
        font-size: 24px;
      }

      .page {
        max-height: calc(100vh - 84px - 60px);
        min-height: 500px;
        padding-top: 20px;
        padding-bottom: 40px;
        padding-left: 30px;
        padding-right: 30px;
        overflow-y: auto;
      }

      #menu {
        width: calc(100%);
        height: calc(100vh - 72px);
        position: absolute;
        top: 72px;
        left: 0;
        z-index: 999;
        transform: translateX(-100vw);
        transition-duration: 400ms;
        background-color: var(--menu-color);
        color: var(--text-color-light);
        display: flex;
        flex-direction: column;
      }

      :host([showMenu]) #menu {
        transition-duration: 500ms;
        transform: translateX(0);
      }

      #close-button {
        position: absolute;
        right: 0;
      }

      #close-button:hover {
        cursor: pointer;
        background-color: var(--primary-hover-color);
      }

      .menu-item {
        color: var(--text-color-light);
        font-size: 21px;
        font-weight: bold;
        text-decoration: none;
        text-align: left;
        display: flex;
        flex-direction: row;
      }

      .menu-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;
      }

      .menu-item:hover {
        background-color: var(--primary-hover-color);
      }

      #user-icon {
        cursor: initial;
      }

      #user-text {
        cursor: initial;
      }

      #modal {
        position: absolute;
        transform: translateY(-200px);
        transition-duration: 1s;

        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        width: 80vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 99999;
      }

      :host([notificationVisible]) #modal {
        transition-duration: 500ms;
        transform: translateY(20px);
      }

      .modal-content {
        color: var(--text-color-light);
        border-radius: 10px;
        background-color: var(--text-color-main);
        width: 80vw;
        height: auto;
        padding: 10px;
      }

      #versionModal {
        position: absolute;
        transform: translateY(-100vh);
        transition-duration: 1s;
        display: none;

        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;

        align-items: center;
        z-index: 9999;
      }

      .version-modal-content {
        color: var(--text-color-light);
        border-radius: 10px;

        background-color: var(--menu-color);
        box-shadow: 0px 0px 0px 1px white;

        box-shadow:
          0.25rem 0.25rem 0.6rem rgba(0, 0, 0, 0.5),
          0 0.5rem 1.125rem rgba(75, 0, 0, 0.05);
        width: 80vw;
        padding: 10px;
        height: calc(100vh - 140px);
      }

      :host([versionPopupVisible]) #versionModal {
        transition-duration: 500ms;
        transform: translateY(0px);
      }

      #confirmModal {
        position: absolute;

        width: 100vw;
        height: 100vh;
        display: none;
        flex-direction: column;
        justify-content: center;

        align-items: center;
        z-index: 9999;
      }

      :host([confirmPopupVisible]) #confirmModal {
        display: flex;
        background-color: rgba(0, 0, 0, 0.6);
      }

      .confirm-modal-content {
        border-radius: 10px;

        color: var(--text-color-main);
        background-color: var(--background-color);
        box-shadow: 0px 0px 0px 1px white;

        box-shadow:
          0.25rem 0.25rem 0.6rem rgba(0, 0, 0, 0.5),
          0 0.5rem 1.125rem rgba(75, 0, 0, 0.05);
        padding-left: 40px;
        padding-right: 40px;
        padding-top: 15px;
        padding-bottom: 40px;
      }

      a {
        color: white;
        text-decoration: none;
      }

      #buttonWrapper {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      #button {
        width: 70vw;
        background-color: var(--primary-color);
        padding: 12px;
        color: white;
        border-radius: 10px;
        font-weight: bold;
        max-width: 300px;
      }

      #nope {
        margin-top: 20px;
      }

      .headerLogoContainer {
        display: flex;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        height: 82px;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
      }

      .grow {
        flex-grow: 1;
      }

      .headerLogoWrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        width: 100%;
        max-width: 319.6px;
      }

      #headerLogo {
        padding: 0px;
        height: auto;
        width: auto;
        max-height: 50px;
      }

      langhout-button {
        max-width: 200px;
        width: 200px;
        min-width: 180px;
        margin-right: 20px;
        margin-top: 20px;
      }

      .row {
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        flex-flow: row wrap;
        justify-content: center;
      }
    `,
  ];

  @property({ type: Boolean, reflect: true })
  public notificationVisible?: boolean;

  @property({ type: Boolean, reflect: true })
  public versionPopupVisible = false;

  @property({ type: Boolean, reflect: true })
  public confirmPopupVisible = false;

  @property({ type: Object, reflect: true })
  private confirmEvent: ConfirmEvent = <ConfirmEvent>{};

  @property({ type: Boolean, reflect: true })
  public showMenu = false;

  @query('#outlet')
  private outletElem?: HTMLDivElement;

  private router?: Router;

  @property({ type: String, reflect: true })
  public message?: string;

  @property({ type: String, reflect: true })
  public version?: string;

  @property({ type: Object, reflect: true })
  public user?: User;

  private webSocket?: WebSocket;

  private backOff = 0;

  constructor() {
    super();
    this.refreshTokenCall();
    this.refreshOTPTokenCall();
    this.getUserCall();
    window.addEventListener(
      'vaadin-router-location-changed',
      this.routerLocationChanged as EventListener,
    );
    document.addEventListener(
      'show-notification',
      this.showNotification as EventListener,
    );
    document.addEventListener(
      'confirm-event',
      this.showConfirmPopup as EventListener,
    );
    this.notificationVisible = false;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      'vaadin-router-location-changed',
      this.routerLocationChanged as EventListener,
    );
    document.removeEventListener(
      'show-notification-event',
      this.showNotification as EventListener,
    );
    document.removeEventListener(
      'confirm-event',
      this.showConfirmPopup as EventListener,
    );
    if (this.webSocket) {
      this.webSocket.close();
    }
  }

  private showNotification = (e: CustomEvent): void => {
    this.notificationVisible = true;
    this.message = e.detail.value;
    setTimeout(() => {
      this.notificationVisible = false;
    }, 5000);
  };

  private showConfirmPopup = (e: CustomEvent): void => {
    this.confirmPopupVisible = true;
    this.confirmEvent = JSON.parse(e.detail.value);
  };

  protected firstUpdated = (): void => {
    if (!this.router && this.outletElem) {
      this.router = new Router(this.outletElem);

      this.router.setRoutes([
        { path: '/', component: 'langhout-beton-list-orders' },
        {
          path: '/retour-orders',
          component: 'langhout-beton-list-retour-orders',
        },
        {
          path: '/create-retour-order',
          component: 'langhout-beton-create-retour-order',
        },
        { path: '/login', component: 'login-element' },
        {
          path: '/create-pickup-order',
          component: 'langhout-beton-create-pickup-order',
        },
        {
          path: '/finished-orders',
          component: 'langhout-beton-list-finished-orders',
        },
        {
          path: '/accounts',
          component: 'langhout-beton-list-accounts',
        },
        {
          path: '/view-stock',
          component: 'langhout-beton-view-stock',
        },
        {
          path: '/view-retour-order',
          component: 'langhout-beton-view-retour-order',
        },
        {
          path: '/update-retour-order',
          component: 'langhout-beton-update-retour-order',
        },
        {
          path: '/view-stock-count',
          component: 'langhout-beton-view-stock-count',
        },
        {
          path: '/stock',
          component: 'langhout-beton-list-stock',
        },
        {
          path: '/templates',
          component: 'langhout-beton-list-templates',
        },
        {
          path: '/users',
          component: 'langhout-beton-list-users',
        },
        {
          path: '/edit-user',
          component: 'langhout-beton-edit-users',
        },
        {
          path: '/stock-count',
          component: 'langhout-beton-list-stock-count',
        },
        {
          path: '/production-planning',
          component: 'langhout-beton-view-production-planning',
        },
      ]);
    }
  };

  connectWebsocket = () => {
    if (!this.webSocket) {
      const jwtFromStorage = localStorage.getItem(JWT_KEY_LOCALSTORAGE);
      if (!jwtFromStorage) {
        setTimeout(() => {
          this.connectWebsocket();
        }, 100);
        return;
      }
      this.webSocket = new WebSocket(
        `wss://${DOMAIN}/pickuporders/websocket/portal?token=Bearer ${jwtFromStorage}`,
      );
      this.webSocket.onclose = evt => {
        this.backOff++;
        console.warn('websocket closed', evt);
        this.webSocket = undefined;
        setTimeout(() => {
          this.connectWebsocket();
        }, 100 * this.backOff);
      };
      this.webSocket.onmessage = () => {
        this.backOff = 0;
        if (window.location.pathname === '/') {
          showNotification('Refreshing Pickup Orders');
        }
        const event = new CustomEvent('refresh-pickup-orders', {
          detail: {},
          bubbles: true,
        });
        this.dispatchEvent(event);
      };
      this.webSocket.onerror = evt => {
        console.warn('ERROR: ', evt);
      };
    }
  };

  protected routerLocationChanged = (): void => {
    if (!this.router) {
      console.log('no router', this.router);
      console.log('no outletElem', this.outletElem);
      return;
    }

    const jwt = localStorage.getItem(JWT_KEY_LOCALSTORAGE);
    if (!jwt && !window.location.href.endsWith('/login')) {
      window.location.href = '/login';
    }
    this.setTitle();
  };

  protected setTitle() {
    const currentPath = getCurrentPath();
    if (currentPath === '/login') {
      this.title = 'Login';
    } else if (currentPath === '/create-pickup-order') {
      this.title = 'Invoeren';
    } else if (currentPath === '/templates') {
      this.title = 'Templates';
    } else if (currentPath === '/finished-orders') {
      this.title = 'Afgerond';
    } else if (currentPath === '/accounts') {
      this.title = 'Relaties';
    } else if (currentPath === '/users') {
      this.title = 'Gebruikers';
    } else if (currentPath === '/stock' || currentPath === '/view-stock') {
      this.title = 'Voorraad';
    } else if (currentPath === '/production-planning') {
      this.title = 'Planning';
    } else if (
      currentPath === '/stock-count' ||
      currentPath === '/view-stock-count'
    ) {
      this.title = 'Productie';
    } else if (currentPath === '/') {
      this.title = 'Home';
    } else if (
      currentPath === '/retour-orders' ||
      currentPath === '/view-retour-order' ||
      currentPath === '/update-retour-order' ||
      currentPath === '/create-retour-order'
    ) {
      this.title = 'Retouren';
    }
  }

  render() {
    return html`
      <style-provider>
        ${CHRISTMAS_THEME_ENABLED ? this.renderSnowflakes() : ''}
        <div id="confirmModal">
          <div class="confirm-modal-content">
            <h1>${this.confirmEvent.title}</h1>
            <div>${unsafeHTML(this.confirmEvent.description)}</div>
            ${this.renderConfirmCheckbox()}
            <div class="row">
              <langhout-button
                text="Annuleren"
                @click="${() => {
                  this.confirmPopupVisible = false;
                }}"
              ></langhout-button>
              <div class="buttonSpacing"></div>
              <langhout-button
                removeButton
                text="Bevestigen"
                @click="${() => {
                  if (!this.shadowRoot) {
                    return;
                  }
                  if (this.confirmEvent.with_checkbox) {
                    const checkbox = this.shadowRoot.querySelector(
                      '#deleteConfirmCheckbox',
                    ) as LanghoutCheckbox;
                    if (!checkbox.checked) {
                      showNotification(
                        'Klik op de checkbox om de actie te bevestigen.',
                      );
                      return;
                    }
                    checkbox.checked = false;
                  }
                  document.dispatchEvent(
                    new CustomEvent(this.confirmEvent.confirm_event, {
                      detail: {},
                      bubbles: true,
                    }),
                  );
                  this.confirmPopupVisible = false;
                }}"
              ></langhout-button>
            </div>
          </div>
        </div>
        <!-- Version popup -->
        <div id="versionModal">
          <div class="version-modal-content">
            <h2>New version available</h2>
            <div>A new app version is available, please update your app.</div>
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.langhoutbeton.app"
            >
              <div id="buttonWrapper">
                <div id="button">Download version ${this.version}</div>
              </div>
            </a>
          </div>
        </div>
        <!-- Message popup -->
        <div id="modal">
          <div class="modal-content">${unsafeHTML(this.message)}</div>
        </div>
        <!-- Menu -->
        <div id="menu">${this.renderMenu()}</div>

        <!-- Normal content -->
        <div
          class="header ${CHRISTMAS_THEME_ENABLED ? 'christmas-accent' : ''}"
        >
          <div
            class="menu-icon"
            @click="${(): void => {
              this.showMenu = !this.showMenu;
            }}"
          >
            ${menuIcon()}
          </div>
          <h2
            id="title"
            @click="${(): void => {
              window.location.href = '/';
            }}"
          >
            ${this.title}
          </h2>
          <div class="headerLogoContainer">
            <div class="grow"></div>
            <div class="headerLogoWrapper">${headerLogo100()}</div>
          </div>
        </div>
        <div class="page">
          <div id="outlet"></div>
        </div>
      </style-provider>
    `;
  }

  renderConfirmCheckbox() {
    if (this.confirmEvent.with_checkbox) {
      return html`<div>
        <langhout-checkbox id="deleteConfirmCheckbox"></langhout-checkbox>${
          this.confirmEvent.checkbox_text
        }
      </div>`;
    }
    return html``;
  }

  renderMenu() {
    return html`
      <div
        id="close-button"
        @click="${(): void => {
          this.showMenu = false;
        }}"
      >
        ${closeIcon()}
      </div>
      <a
        class="menu-item"
        href="/"
        @click="${(): void => {
          this.showMenu = false;
        }}"
      >
        ${homeIcon()}
        <div class="menu-text">Home</div>
      </a>
      <a
        class="menu-item"
        href="/stock-count"
        @click="${(): void => {
          this.showMenu = false;
        }}"
      >
        ${factoryIcon()}
        <div class="menu-text">Productie tellingen</div>
      </a>
      <a
        class="menu-item"
        href="/production-planning"
        @click="${(): void => {
          this.showMenu = false;
        }}"
      >
        ${calendarIcon()}
        <div class="menu-text">Productie planning</div>
      </a>
      <a
        class="menu-item"
        href="/stock"
        @click="${(): void => {
          this.showMenu = false;
        }}"
      >
        ${stockIcon()}
        <div class="menu-text">Voorraad</div>
      </a>
      <a
        class="menu-item"
        @click="${(): void => {
          window.location.href = '/retour-orders';
          this.showMenu = false;
        }}"
      >
        ${retourIcon()}
        <div class="menu-text">Retouren</div>
      </a>
      <a
        class="menu-item"
        href="/create-pickup-order"
        @click="${(): void => {
          this.showMenu = false;
        }}"
      >
        ${createIcon()}
        <div class="menu-text">Pickup order invoeren</div>
      </a>
      <a
        class="menu-item"
        href="/finished-orders"
        @click="${(): void => {
          this.showMenu = false;
        }}"
      >
        ${archiveIcon()}
        <div class="menu-text">Afgeronde orders</div>
      </a>

      ${this.showTemplatesMenu()}
      <a
        class="menu-item"
        href="/accounts"
        @click="${(): void => {
          this.showMenu = false;
        }}"
      >
        ${accountsIcon()}
        <div class="menu-text">Relaties</div>
      </a>
      ${this.showAdminMenu()} ${this.showUserNameMenu()}
      ${this.showLoginItemMenu()}
    `;
  }

  showTemplatesMenu() {
    const jwt = localStorage.getItem(JWT_KEY_LOCALSTORAGE);
    if (!jwt) {
      return html``;
    }
    const isLimitedCrud = hasScope(jwt, 'pickup-order-crud-limited');
    if (isLimitedCrud) {
      return html``;
    }
    return html` <a
      class="menu-item"
      href="/templates"
      @click="${(): void => {
        this.showMenu = false;
      }}"
    >
      ${editIcon()}
      <div class="menu-text">Templates</div>
    </a>`;
  }

  showAdminMenu() {
    const jwt = localStorage.getItem(JWT_KEY_LOCALSTORAGE);
    if (!jwt) {
      return html``;
    }
    const isLimitedCrud = hasScope(jwt, 'pickup-order-crud-limited');
    if (isLimitedCrud) {
      return html``;
    }
    return html` <a
      class="menu-item"
      href="/users"
      @click="${(): void => {
        this.showMenu = false;
      }}"
    >
      ${settingsIcon()}
      <div class="menu-text">Settings</div>
    </a>`;
  }

  showUserNameMenu() {
    if (!this.user) {
      return html``;
    }
    return html`
      <div class="menu-item">
        ${userIcon()}
        <div id="user-text" class="menu-text">
          ${this.user.first_name} ${this.user.last_name}
        </div>
      </div>
    `;
  }

  showLoginItemMenu() {
    const jwt = localStorage.getItem(JWT_OTP_KEY_LOCALSTORAGE);
    if (!jwt) {
      return html` <a
        class="menu-item"
        href="/login"
        @click="${(): void => {
          this.showMenu = false;
        }}"
      >
        ${signInIcon()}
        <div class="menu-text">Login</div>
      </a>`;
    }
    return html` <a
      class="menu-item"
      @click="${(): void => {
        this.showMenu = false;
        localStorage.clear();
        window.location.href = '/';
      }}"
    >
      ${logOutIcon()}
      <div class="menu-text">Logout</div>
    </a>`;
  }

  renderSnowflakes() {
    return html`
      <div class="snowflake">❄</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❄</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❄</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❄</div>
    `;
  }

  registerPushNotification = async (token: string) => {
    authenticatedAPICall(
      '/push-notification/register',
      'POST',
      new Headers(),
      JSON.stringify({
        registration_id: token,
        os_type: Capacitor.getPlatform(),
      }),
    );
  };

  refreshTokenCall = async () => {
    const result = await authenticatedAPICall(
      '/token/refresh',
      'POST',
      new Headers(),
    );
    if (!isSuccessfulAPIResponse(result)) {
      if (!window.location.href.endsWith('/login')) {
        this.showMenu = false;
        localStorage.removeItem(JWT_KEY_LOCALSTORAGE);
        window.location.href = '/login';
      }
      return;
    }
    localStorage.setItem(JWT_KEY_LOCALSTORAGE, result.body.access_token);
    this.connectWebsocket();
  };

  getUserCall = async () => {
    const jwt = localStorage.getItem(JWT_KEY_LOCALSTORAGE);
    if (!jwt) {
      return;
    }
    const claims: Claims = jwtDecode(jwt);
    const result = await authenticatedAPICall(
      `/users/${claims.sub}`,
      'GET',
      new Headers(),
    );
    if (isSuccessfulAPIResponse(result)) {
      this.user = result.body;
    }
  };

  refreshOTPTokenCall = async () => {
    const result = await authenticatedAPICall(
      '/token/refresh/otp',
      'POST',
      new Headers(),
      null,
      JWT_OTP_KEY_LOCALSTORAGE,
    );
    if (isSuccessfulAPIResponse(result)) {
      localStorage.setItem(JWT_OTP_KEY_LOCALSTORAGE, result.body.access_token);
    } else if (result.statusCode == 401) {
      localStorage.removeItem(JWT_OTP_KEY_LOCALSTORAGE);
      window.location.href = '/login';
    }
  };

  latestVersionCall = async () => {
    const result = await authenticatedAPICall(
      '/version/app',
      'GET',
      new Headers(),
    );
    if (!isSuccessfulAPIResponse(result)) {
      return;
    }
    this.version = result.body.version;
    if (!this.isLatestVersion(result.body.version, currentVersion)) {
      this.versionPopupVisible = true;
    }
  };

  isLatestVersion = (backendVersion: string, appVersion: string): boolean => {
    backendVersion = backendVersion.substring(1);
    appVersion = appVersion.substring(1);
    const appVersionSplitted = appVersion.split('.');
    const backendVersionSplitted = backendVersion.split('.');
    if (appVersionSplitted.length !== backendVersionSplitted.length) {
      console.warn('could not compare versions');
      return true;
    }
    for (let i = 0; i < appVersionSplitted.length; i++) {
      if (
        parseInt(appVersionSplitted[i]) > parseInt(backendVersionSplitted[i])
      ) {
        return true;
      }
      if (
        parseInt(backendVersionSplitted[i]) > parseInt(appVersionSplitted[i])
      ) {
        return false;
      }
    }
    return true;
  };
}

export const notificationEvent: (message: string) => CustomEvent = (
  message: string,
): CustomEvent => {
  return new CustomEvent('show-notification', {
    detail: {
      value: message,
    },
    bubbles: true,
  });
};

export const showNotification: (message: string) => void = (
  message: string,
): void => {
  document.dispatchEvent(notificationEvent(message));
};

export const confirmEventEvent: (confirmEvent: ConfirmEvent) => CustomEvent = (
  confirmEvent: ConfirmEvent,
): CustomEvent => {
  return new CustomEvent('confirm-event', {
    detail: {
      value: JSON.stringify(confirmEvent),
    },
    bubbles: true,
  });
};

export const confirmPopup: (confirmEvent: ConfirmEvent) => void = (
  confirmEvent: ConfirmEvent,
): void => {
  document.dispatchEvent(confirmEventEvent(confirmEvent));
};
